import { koComponent } from '../../ko-utils';
import * as siteConfig from '../../site-config/trackableConfig';
import { beginNoTracking, endNoTracking } from '../../utils/changeTracking';

class UrlFilterDescriptor {
    constructor(params) {
        this.root = params.$raw.rootElement();

        if (!this.root()) {
            this.root.noTracking = true;
            this.root(new siteConfig.UrlFilterDescriptor());
            this.root.noTracking = false;

            beginNoTracking(this.root());
            this.root().type('include');
            endNoTracking(this.root());
        }

        this.descriptor = this.root();
    }

    addUrl() {
        this.descriptor.urls.push(new siteConfig.StringValue());
    }

    removeUrl(url) {
        this.descriptor.urls.remove(url);
    }

    //debug() {
    //    console.log('RULES', this.mainRulesGroup.toJS());
    //}
}

export default koComponent('url-filter-descriptor', UrlFilterDescriptor);

export function areUrlsDefined(urlsObject) {
    const obj = ko.unwrap(urlsObject);
    return obj && obj.urls && ko.unwrap(obj.urls).length > 0;
}